import { BRAND } from "constants/brand";
import { useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";

import { Form } from "react-bootstrap";

import { CSSTransition } from "react-transition-group";
import { Ring } from "@uiball/loaders";
import useProduct from "hooks/useProducts";
import { useGetVendorsDropdown } from "hooks/useVendors";
import { fieldOf } from "utils/formField";

const CopyProducts = (props) => {
    const form = useRef();
    const nodeRef = useRef();
    const { loading, copyProducts, error } = useProduct();

    const { vendors } = useGetVendorsDropdown();

    const submitHandler = async (e) => {
        e.preventDefault();
        const data = {
            vendorId: fieldOf(form.current, "vendorId").value,
            targetVendor: props.targetVendor,
        };

        // If copying selected products, include their IDs
        if (props.productIds && props.productIds.length > 0) {
            data.productIds = props.productIds;
        }

        try {
            await copyProducts(data);
            props.showMessage("success", "تمت الاضافه", "تمت إضافه المنتجات بنجاح");
            props.close();
        } catch (err) {
            console.error("Error copying products:", err);
            props.showMessage("error", "هناك خطأ", error || "حدث خطأ غير متوقع");
        }
    };

    return (
        <>
            <div className={`model ${props.show ? "model-show" : ""}`} onClick={props.close}>
                <CSSTransition
                    mountOnEnter
                    unmountOnExit
                    nodeRef={nodeRef}
                    in={props.show}
                    timeout={400}
                    classNames="show"
                >
                    <div className="addItem" ref={nodeRef} onClick={(e) => e.stopPropagation()}>
                        {loading ? (
                            <div className="loading-spinner center">
                                <Ring size={40} lineWeight={5} speed={2} color={BRAND} />
                            </div>
                        ) : null}
                        <div className="head center">
                            <h5>
                                {props.copyMode === "selected"
                                    ? `نسخ المنتجات المحدده (${props.productIds?.length || 0}) الي مطعم`
                                    : "نسخ جميع المنتجات الي مطعم"}
                            </h5>
                            <FontAwesomeIcon icon={faClose} onClick={props.close} />
                        </div>
                        <Form className="form" ref={form} onSubmit={submitHandler}>
                            <Form.Group className="mb-3" controlId="vendor">
                                <Form.Label>
                                    المطعم<span style={{ color: "red" }}>*</span>
                                </Form.Label>
                                <Form.Select name="vendorId" required>
                                    <option value={""}>----</option>
                                    {vendors?.map((vendor) => (
                                        <option key={vendor.id} value={vendor.id}>
                                            {vendor.name}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>

                            <div className="buttons">
                                <button className="cancel" onClick={props.close} type="button">
                                    إلغاء
                                </button>
                                <button className="button" type="submit">
                                    نسخ المنتجات
                                </button>
                            </div>
                        </Form>
                    </div>
                </CSSTransition>
            </div>
        </>
    );
};
export default CopyProducts;
